export const environment = {
  production: false,
  api_key: 'xt3diwahca6b16qh9cvim1df5rbebkwhwc0j852qh1jekyanrt35tispjurx3mf8bfe4h8l321nf0ygop5a99l0oywdfolf8xgeadv9y1nmnkdimnr37ifgl91f4hgcelma5p9gg9jyq0ivvswa59vdeij48rdbtq7b95p30y8jobcc57nw7ukcqvejo5p0uoj515c4vdjcoj4rigvc3sct73q49h0qrh8dvoupwj1wnfv6ymmtugjpi0ooh3pux',
  apiUrl: 'https://m.int.pratiquants.ffck.snapp.fr',
  apiVersion: '/admin',
  perPage: 12,
};
